import { StyledParagraph } from '@components/Text';
import { DisplayH1, DisplayH2 } from '@components/Text/HeadingTagDisplay.style';
import { HeadingColor, ImgWH, ImgWidth100, LabelColor, ParagraphColor, Spacing, SpacingDTM } from '@pages/CommonStyle/common.style';
import os from '@src/lang/ko/main/os/os';
import React, { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';
import { Card, CardDesc, CardLayout, CardOverlay, ToggleBtn } from '../../Os.style';
import { DivAllCenter, DivFlexColumn, DivGridGap } from '@pages/CommonStyle/commonDiv.style';
import { HeadingH3, HeadingH3white } from '@components/Text/Heading/Heading.style';
import { Link } from 'react-router-dom';
import { ShowMoreButton } from '@pages/CommonStyle/commonBtn';
import simple from '@src/lang/ko/simple';
import i18n from '@pages/i18n';
import { useSelector } from 'react-redux';
import { CommonState } from '@redux/reducers/commonReducer';
import { osBanner } from '@assets/images/main/os/bannerImg';
import { OsServerImg, OsTagSection } from './HeadSection.style';
export const SpaceBar = () => <>&nbsp;</>;

const HeadSection = () => {
  const layoutType = useSelector((state: CommonState) => state.gridLayoutType);

  return (
    <>
      <Spacing pixel="64" />

      <DivAllCenter>
        <ImgWidth100 src={os.osLogo[layoutType]} />
        <Spacing pixel="16" />
        <DisplayH1 size={'medium'}>
          <Trans i18nKey={`os.title`} />
        </DisplayH1>
        <Spacing pixel="16" />
        <StyledParagraph size={'medium'}>
          <p>
            <Trans i18nKey={`os.desc`} />
          </p>
        </StyledParagraph>
      </DivAllCenter>
      <ImgWidth100 src={osBanner} />

      <SpacingDTM d={'256'} t={'128'} m={'96'} />

      <DisplayH2 size={'small'}>
        <Trans i18nKey={`os.section.title`} />
      </DisplayH2>

      <Spacing pixel="16" />
      <StyledParagraph size={'medium'}>
        <Trans i18nKey={`os.section.desc`} />
      </StyledParagraph>

      <Spacing pixel="48" />
      <OsTagSection cnt={3} gap={32}>
        {os.section.tag.map((data, i) => (
          <>
            <DivFlexColumn>
              <ImgWH w="36" h="36" src={data.icon} />
              <Spacing pixel="8" />
              <HeadingColor color="#000" size="xxsmall">
                <Trans i18nKey={`os.section.tag.${i}.title`} />
              </HeadingColor>
              <Spacing pixel="8" />
              <StyledParagraph size={'medium'}>
                <Trans i18nKey={`os.section.tag.${i}.desc`} />
              </StyledParagraph>
            </DivFlexColumn>
          </>
        ))}
      </OsTagSection>

      <SpacingDTM d="128" t="96" m="48" />

      <OsServerImg src={osBanner} />
    </>
  );
};

export default HeadSection;
